import React from 'react';
import List from '@mui/material/List';

import { companyTypes, policiesType } from '../../context';
import { PoliciesCollapse, PoliciesListItem } from '..';

interface PoliciesListsProps {
    policies: policiesType;
    company: companyTypes;
}

export const PoliciesList: React.FC<PoliciesListsProps> = React.memo(
    ({ policies, company }) => {
        return (
            <>
                {policies.map(policy =>
                    policy.Variant === 'folder' ? (
                        <PoliciesCollapse key={policy.Reference} title={policy.Name}>
                            {policy.Policies?.map(subPolicy => (
                                <List sx={{ background: '#e0e0e0' }} disablePadding>
                                    <PoliciesListItem
                                        key={subPolicy.Reference}
                                        policy={subPolicy}
                                        company={company}
                                        sx={{ pl: 4 }}
                                    />
                                </List>
                            ))}
                        </PoliciesCollapse>
                    ) : (
                        <PoliciesListItem
                            key={policy.Reference}
                            policy={policy}
                            company={company}
                        />
                    )
                )}
            </>
        );
    }
);
